import { Modal } from '@hevoio/hevo-ui-toolkit';
import { IconId } from '@tabler/icons-react';
import React, { useState } from 'react';
import { HdSupportButton } from '../../../../support/components/support-button/SupportButton';
import { getUnreadDisplayCount } from '../../../../core/utils/string';
import {
  TRACKER_SUPPORT_MENU_CONTACT_MANAGER_CLICK,
  TRACKER_SUPPORT_MENU_CTA_CLICK, TRACKER_SUPPORT_MENU_CTA_HOVER
} from '../../../../core/constants/constants';
import { AppbarItemWithMenu } from '../appbar-item-with-menu/AppbarItemWithMenu';
import { AppbarMenuItem } from '../appbar-item-with-menu/AppbarMenuItem';
import { AccountManagerContactDialog } from '../../../../support/components/account-manager-contact-dialog/AccountManagerContactDialog';
import { AppbarSupportCTA } from './AppbarSupportCTA';
import { LiveSupportMenuItemComponent } from './LiveSupportMenuItemComponent';

export function AppbarSupportCTAWithMenu({
  supportUnreadCount,
  canShowOnCallSupportIndicator,
  expanded = false
}: {
  supportUnreadCount: number;
  canShowOnCallSupportIndicator: boolean;
  expanded?: boolean;
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <AppbarItemWithMenu
        open={menuOpen}
        setOpen={setMenuOpen}
        Item={AppbarSupportCTA}
        hoverTrackingAction={TRACKER_SUPPORT_MENU_CTA_HOVER}
        itemProps={{
          iconName: 'human-chat',
          label: 'Support',
          badgeContent: supportUnreadCount ? getUnreadDisplayCount(supportUnreadCount) : '',
          showOnCallSupportIndicator: canShowOnCallSupportIndicator,
          trackingEvent: TRACKER_SUPPORT_MENU_CTA_CLICK,
          expanded,
          disableTooltip: true
        }}
      >
        <AppbarMenuItem
          SVGIcon={IconId}
          onClick={() => {
            setDialogOpen(!dialogOpen);
            setMenuOpen(false);
          }}
          trackingEvent={TRACKER_SUPPORT_MENU_CONTACT_MANAGER_CLICK}
        >
          Contact Account Manager
        </AppbarMenuItem>

        <HdSupportButton
          supportUnreadCount={supportUnreadCount}
          onClick={(result: boolean) => {
            if (result) {
              setMenuOpen(false);
            }
          }}
          Component={LiveSupportMenuItemComponent}
        />
      </AppbarItemWithMenu>

      <Modal open={dialogOpen} onClose={() => setDialogOpen(false)} styling={{ width: '560px' }} >
        <AccountManagerContactDialog onClose={() => setDialogOpen(false)} />
      </Modal>
    </>
  );
}
